import React from 'react';

import IconGeneric from '../icon/icon-generic';

class FormSimpleToggle extends React.Component {
  static defaultProps = {
    id: '',
    value: '',
    tracking: '',
    label: null,
    cy: null,
    icon: ''
  };

  handleOnClick = () => {
    const { onChange, value, checked } = this.props;
    onChange(null, value, !checked);
  };

  getDefaultClassNamesWithTracking = () => {
    return `simple-toggle__input ${this.props.tracking}`;
  };

  getIcon = () => {
    const { checked, icon } = this.props;
    const color = !checked && 'grey';

    return icon && <IconGeneric name={icon} color={color} size="large" />;
  };

  render() {
    const icon = this.getIcon();
    const { id, value, label, checked, cy } = this.props;

    return (
      <div className="simple-toggle">
        <input
          className={this.getDefaultClassNamesWithTracking()}
          type="checkbox"
          id={id}
          data-cy={cy}
          value={value}
          onChange={this.handleOnClick}
          checked={checked}
        />
        <label className="simple-toggle__label" htmlFor={id}>
          {icon}
          {label}
        </label>
      </div>
    );
  }
}

export default FormSimpleToggle;
